import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const t = localStorage.getItem("pd_token");
    if (!t) { setUser(null); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("pd_token"); setUser(null); });
  }, []);

  const login = async (username, password, counter_id) => {
    const r = await api.post("/auth/login", { username, password, counter_id: counter_id || undefined });
    localStorage.setItem("pd_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    // Record the logout (best effort) before the token is dropped.
    if (localStorage.getItem("pd_token")) api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("pd_token");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
